import React from "react";
import { useEffect } from "react";
import { useParams } from "react-router-dom";
import { blogContent } from "../../utils/blogs";
import Footer from "./Footer";
import { LayoutForLandingPage } from "./Home";

const FullBlog = () => {
  const { id } = useParams();
  const [data, setData] = React.useState({});
  useEffect(() => {
    if (id) {
      const data1 = blogContent.find((blog) => blog.id === parseInt(id));
      setData(data1);
    }
  }, [id]);
  return (
    <>
<LayoutForLandingPage>

      <div className="w-full flex flex-col justify-center items-center  mt-20">
        <img
          src={data?.image}
          alt="Blog"
          className="rounded-md p-2"
          width={800}
        />
        <h2 className="text-[#2F3649] text-[28px] font-semibold mt-4">
          {data?.title}
        </h2>
        <div className="mt-4">
          <ul className="list-disc text-[18px] pl-4 text-gray-700 leading-relaxed">
            {data?.content?.map((paragraph, idx) => (
              <li key={idx} className="mt-2 text-[19px]">
                {paragraph}
              </li>
            ))}
          </ul>
        </div>
      </div>
</LayoutForLandingPage>
      <Footer />
    </>
    
  );
};

export default FullBlog;
